import { captureException } from '@sentry/react';
import { addSocketUser } from '../actions/socketActions';
import baseApi, { TAGS } from '../api/baseApi';
import { map } from 'lodash';

/************************************************** API **************************************************/
export const userApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getNumBlueDots: builder.query({
      query: () => ({
        url: 'bookkeeper-assignments/blue-dots/available/count',
        method: 'GET'
      }),
      transformResponse: (response) => response.data,
      providesTags: [TAGS.NUM_BLUE_DOTS]
    }),
    addBlueDots: builder.mutation({
      query: () => ({
        url: 'bookkeeper-assignments/blue-dots',
        method: 'POST'
      }),
      transformResponse: (response) => response.data,
      invalidatesTags: [TAGS.USER_LIST],
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          const { newAssignments } = data;
          const newAssignmentsUserIds = map(newAssignments, 'userId');
          // Add any new user IDs to list of users to watch for socket events
          for (const userId of newAssignmentsUserIds) {
            dispatch(addSocketUser(userId));
          }
        } catch (e) {
          captureException(e);
        }
      }
    })
  })
});

/************************************************** HOOKS **************************************************/
export const { useGetNumBlueDotsQuery, useAddBlueDotsMutation } = userApi;
